export default import.meta.ROLLDOWN_FILE_URL_0R6aCHMCVUPf9apLhFubFA